import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "user";

const GET_ALL_USER_URL = `${prefix}/all`;
const GET_USER_BY_ID_URL = `${prefix}/get-by-id`;
const GET_USER_ME_URL = `${prefix}/get-user-me`;
const LOGIN_URL = `${prefix}/login`;
const CHECK_USER_REGISTER_URL = `${prefix}/check-user-account`;
const REGISTER_URL = `${prefix}/register`;
const UPDATE_USER_BY_ID_URL = `${prefix}/update-by-id`;
const DELETE_USER_BY_ID_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllUser
 * @desc get all user data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getAllUser = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_USER_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllUser");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllUser */

/**
 * Start
 * @func getUserById
 * @desc get user by id
 * @author izeberg
 * @param {number} id - user id
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} user data
 */
export const getUserById = async (id, signal) => {
    try {
        const { data, status } = await axios.get(`${GET_USER_BY_ID_URL}/${id}`, { signal });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getUserById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getUserById */

/**
 * Start
 * @func getUserMe
 * @desc get user data by token
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} user data
 */
export const getUserMe = async signal => {
    try {
        const { data, status } = await axios.get(GET_USER_ME_URL, { signal });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getUserMe");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getUserMe */

/**
 * @func loginSystem
 * @desc user login
 * @author izeberg
 * @param {string} username - login username
 * @param {string} password - login password
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} login token
 */
export const loginSystem = async (username, password, signal) => {
    try {
        const { data, status } = await axios.post(
            LOGIN_URL,
            { username, password },
            {
                signal,
                withCredentials: true
            },
        );
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "loginSystem");
        if (err) throw err;
        return undefined;
    }
};
/** End @func loginSystem */

/**
 * @func checkUserRegister
 * @desc check existing user account in system
 * @author izeberg
 * @param {string} username - login username
 * @param {string} googleAccessToken - google signin token
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} account found (return token), account not found (return message คุณยังไม่มีบัญชีเลย)
 */
export const checkUserRegister = async (username, googleAccessToken, signal) => {
    try {
        const { data, status } = await axios.get(`${CHECK_USER_REGISTER_URL}/${username}/${googleAccessToken}`, {
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "checkUserRegister");
        if (err) throw err;
        return undefined;
    }
};
/** End @func checkUserRegister */

/**
 * @func registerSystem
 * @desc user register
 * @author izeberg
 * @param {Object} body - create user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} create status
 */
export const registerSystem = async (body, signal) => {
    try {
        const { status } = await axios.post(REGISTER_URL, body, { signal });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "registerSystem");
        if (err) throw err;
        return undefined;
    }
};
/** End @func registerSystem */

/**
 * @func updateUserById
 * @desc update user by id
 * @author izeberg
 * @param {number} id - user id
 * @param {Object} body - update user body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const updateUserById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_USER_BY_ID_URL}/${id}`, body, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateUserById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateUserById */

/**
 * @func deleteUserById
 * @desc delete user by id
 * @author izeberg
 * @param {number} id - user id
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} delete status
 */
export const deleteUserById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_USER_BY_ID_URL}/${id}`, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteUserById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteUserById */
